<template>
  <button :type="nativeType" class="my-button-box">
    <slot></slot>
  </button>
</template>
<script>
// <Button2></Button2>

export default {
  name: 'Button2',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {

    }
  },
  methods: {

  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
.my-button-box{
  height: 40px;
  line-height: 40px;
  background:rgba(2,134,223,0.5);
  border: 1px solid #e5f3fc;
  padding: 0 21px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor:not-allowed;
  outline: none;
  &:hover{
    // border: 1px solid #409ee9;
  }

}
</style>
